const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
  <defs>
    <linearGradient id="roboGrad" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#E2F0FF" />
      <stop offset="100%" stop-color="#B8D8FF" />
    </linearGradient>
  </defs>

  <g stroke="#2B3A55" stroke-width="2" fill="#FFD93D">
    <circle cx="85" cy="30" r="6" />
    <path d="M85 22V24 M85 36V38 M93 30H91 M77 30H79" stroke-linecap="round"/>
    <circle cx="15" cy="75" r="5" fill="#A8B2C1"/>
     <path d="M15 68V70 M15 80V82 M22 75H20 M8 75H10" stroke-linecap="round"/>
  </g>

  <path d="M 25 60 Q 15 55, 30 45" fill="none" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>
  <path d="M 28 43 L 22 37 M 32 47 L 36 43" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>

  <path d="M 75 60 Q 85 65, 80 80" fill="none" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>

  <rect x="35" y="55" width="30" height="30" rx="8" fill="url(#roboGrad)" stroke="#2B3A55" stroke-width="4"/>

  <rect x="25" y="20" width="50" height="35" rx="12" fill="url(#roboGrad)" stroke="#2B3A55" stroke-width="4"/>

  <line x1="50" y1="20" x2="50" y2="10" stroke="#2B3A55" stroke-width="4" stroke-linecap="round"/>
  <circle cx="50" cy="8" r="4" fill="#FFD93D" stroke="#2B3A55" stroke-width="2"/>

  <circle cx="40" cy="38" r="4" fill="#2B3A55"/>
  <circle cx="60" cy="38" r="4" fill="#2B3A55"/>
</svg>`;

export const loading = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
